import { Pipe, PipeTransform } from '@angular/core';
import { ErrorIfMissingPipe } from './error-if-missing.pipe';
import { AbstractMissingPromptPipe } from './abstract-missing-prompt.pipe';

@Pipe({
  name: 'missingUserSegmentSelectionPrompt',
  pure: false,
})
export class MissingUserSegmentSelectionPromptPipe extends AbstractMissingPromptPipe implements PipeTransform {
  protected readonly promptText = 'Select at least one user segment';

  constructor(errorIfMissingPipe: ErrorIfMissingPipe) {
    super(errorIfMissingPipe);
  }
}
